<template>
    <div id="appointment-list">
        <div class="row topactionform">
            <div class="col-xs-5" style="padding-right: 0">
                <div class="smalltitle">Service list</div>
            </div>
            <div class="col-xs-5">
                <form class="onelineform flowsearch" @submit.prevent="filterService">

                    <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
                            class="fa fa-search"></i></button>
                    <input type="text" placeholder="Title or leave blank for search all"
                           v-model="formSearch.keySearch"
                           class="keyinput" style="width: 50%; border-left: 1px solid #e1e1e1; float: right">
                </form>

            </div>
            <div class="col-xs-2">
                <button class="btn light btn-block" @click.prevent="showModalCreateNew"> Create New</button>
            </div>
        </div>
        <div class="blockcont">
            <ul class="itemlisttable  ptemr-list">
                <li class="itemlisthead">
                    <div class="item-name">Title</div>
                    <div class="item-action">Action</div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
                        class="fas fa-spinner fa-spin"></i></li>
                <li v-if="!isLoading && dataServices.length === 0" style="text-align: center; font-size: 16pt">
                    No records found
                </li>
                <li v-if="!isLoading" class="item-service" v-for="(item, index) in dataServices">
                    <div class="item-name">{{item.title}}</div>
                    <div class="item-action itemaction">
                        <dropdown>
                            <a href="javascript:void(0)" title="Choose action" data-toggle="dropdown"><i
                                    class="fa fa-cog"></i></a>
                            <template slot="dropdown">
                                <div>
                                    <a href="javascript:void(0)" title="Edit"
                                       @click.prevent="editService(item)">Edit</a>
                                    <a href="javascript:void(0)" title="Delete" @click.prevent="deleteService(item)">Delete</a>
                                </div>

                            </template>
                        </dropdown>
                    </div>
                </li>
            </ul>
        </div>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>
        <modal-new-service-setup
                v-if="dataCreate.modal"
                :serviceEdit="dataCreate.service"
                @updateModal="dataCreate.modal = $event"
                @createNew="eventCreateNewService"
        ></modal-new-service-setup>
    </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import httpClient from '../../client'
import moment from 'moment'
import config from '../../config'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import CommonMixin from '../../mixins/general/CommonMixin.vue'
import TimeMixin from '../../mixins/general/TimeMixin.vue'

const ModalNewServiceSetup = () => import('./part-service-setup/ModalNewServiceSetup')
export default {
  name: 'Doctor',
  components: {
    Pagination,
    ModalNewServiceSetup
  },
  mixins: [CommonMixin, TimeMixin],
  data () {
    return {
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      formSearch: {
        keySearch: ''
      },
      dataServices: [],
      dataCreate: {
        modal: false,
        service: null
      }
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    this.loadListService()
  },
  beforeDestroy () {},
  methods: {
    deleteService (item) {
      this.$confirm({
        title: 'Confirm',
        content: `Are you sure to delete this service?`
      }).then(async () => {
        try {
          let response = await httpClient.delete(`/service-setup/${item._id}`)
          if (response.data.s === 200) {
            this.alertSuccess(response.data.msg)
            this.loadListService()
          } else {
            this.alertError(response.data.msg)
          }
        } catch (e) {
          this.alertError('Server error.Try again later')
        }
      })
    },
    editService (item) {
      this.dataCreate.service = item
      this.dataCreate.modal = true
    },
    eventCreateNewService () {
      this.loadListService()
    },
    showModalCreateNew () {
      this.dataCreate.modal = true
      this.dataCreate.service = null
    },
    filterService () {
      this.loadListService()
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListService()
    },
    async loadListService () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch
      }
      let response = await httpClient.get(`/service-setup`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          let services = response.data.data.services.data ? response.data.data.services.data : []
          this.dataServices = services
          this.paginate.page = Number(response.data.data.services.currentPage)
          this.paginate.total = response.data.data.services.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    }
  }
}
</script>
<style>

</style>
<style scoped="">
    .onelineform {
        border-left: none !important;
    }

    .item-name {
        width: 80% !important;
        float: left !important;
        min-height: 1px !important;
        cursor: pointer;
    }

    .item-action {
        width: 5% !important;
        float: right !important;
        text-align: right;
        padding-right: 15px;
    }
</style>
